module.exports = __webpack_public_path__ + "static/team_05-7dc6ef8bd78f9cbede03110bc7d8e24f.png";